import CityPageTemplate from "../city-template/CityPageTemplate";
import { elyriaConfig } from "./data";

export default function ElyriaPage() {
  return <CityPageTemplate config={elyriaConfig} />;
}